<!-- @format -->

<div class="nav-bar" *ngIf="!isLoadingData">
	<a [routerLink]='["/timesheet"]' [class.active]='isCurrentActiveRoute("/timesheet")'>Timesheet</a>
	<a [routerLink]='["/year-at-a-glance"]' [class.active]='isCurrentActiveRoute("/year-at-a-glance")'>Year at a Glance</a>
	<a [routerLink]='["/approvals"]' [class.active]='isCurrentActiveRoute("/approvals")' *ngIf="isManager()">Approvals</a>
	<a [routerLink]='["/team"]' [class.active]='isCurrentActiveRoute("/team")' *ngIf="isManagerOrTimeKeeper()">Team</a>
	<a [routerLink]='["/delegations"]' [class.active]='isCurrentActiveRoute("/delegations")' *ngIf="isManagerOrTimeKeeper()">Delegations</a>
	<a [routerLink]='["/acting-scheduler"]' [class.active]="isCurrentActiveRoute('/acting-scheduler')" *ngIf="isManagerOrTimeKeeper()"
		>Acting Scheduler</a
	>
	<a [routerLink]='["/posting"]' [class.active]='isCurrentActiveRoute("/posting")' *ngIf="isManagerOrTimeKeeper()">Posting</a>
	<a [routerLink]='["/email-scheduler"]' [class.active]='isCurrentActiveRoute("/email-scheduler")' *ngIf="isManagerOrTimeKeeper()"
		>Email Scheduler</a
	>
</div>
<div class="nav-border-bottom"></div>
